import styled from "@emotion/styled";
import type { FarmPosition } from "@stepfinance/farms";
import type { ConcentratedLiquidityPosition } from "@stepfinance/liquidity";
import { StepAssetBreakdownPopoverChip, StepPopoverCellWrapperWithTokenIcon } from "@stepfinance/react";
import type { FC } from "react";

import { ReactComponent as EditIcon } from "../../../assets/edit.svg";
import { useNavigationContext } from "../../../contexts/navigation";
import { TokenIconLink } from "../../shared";
import { TokenIcon } from "../../TokenIcon";

export type PoolCellProps = (FarmPosition | ConcentratedLiquidityPosition) & { analyticsLink?: string };

export const PoolCell: FC<PoolCellProps> = ({ lpName, liquidity, link, description, kind, analyticsLink }) => {
  const { navigate } = useNavigationContext();
  const poolIconMints = liquidity.map((l) => l.token?.address ?? "");

  return (
    <StepPopoverCellWrapperWithTokenIcon>
      <TokenIcon mintAddress={poolIconMints} />
      <TokenIconLink
        href={analyticsLink || link}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          if (kind === "Step Finance") {
            e.preventDefault();
            navigate(`/farms`);
            return false;
          }
        }}
      >
        {lpName}
      </TokenIconLink>
      {description && (
        <StepAssetBreakdownPopoverChip title="Pool Type" content={<span>{description}</span>} onlyContent />
      )}
      {kind !== "Step Finance" && analyticsLink && (
        <a href={link} target="_blank" rel="noreferrer">
          <EditIconStyled />
        </a>
      )}
    </StepPopoverCellWrapperWithTokenIcon>
  );
};

const EditIconStyled = styled(EditIcon)`
  margin-left: 10px;
  width: 16px;
  height: 16px;
`;
